import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { StyledBoxDown, StyledButton, StyledButtonPlus } from './style';

import TrainingNeedsItem from './TrainingNeedsItem';
import Modal from '../../../core/Modal';
import { TRAINING } from '../../../../constants/literals/modals';
import { moveElementPosition } from '../../../../utils/splices';

class TrainingNeeds extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.dataTrainingNeeds,
      btnIsDisabled: true
    };
  }

  componentDidMount() {
    const { data } = this.state;

    if (data.length === 0) {
      this.handlePlus();
    }
  }

  onClickDelete = index => {
    const { data } = this.state;
    const updatedData = data.filter((ele, i) => i !== index);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onClickOrderArrow = (index, isDown) => {
    const { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    const updatedData = moveElementPosition([...data], index, move);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  getBtnStatus = data => {
    const { dataTrainingNeeds } = this.props;

    return _.isEqual(dataTrainingNeeds, data);
  };

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { data } = this.state;
    const updatedData = data.filter(t => t.trainingId);
    onAcceptModal(updatedData);
  };

  handleChange = (event, index) => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData[index] = {
      ...clonedData[index],
      trainingId: event.id,
      training: event.name
    };
    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handlePlus = () => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData.push({
      trainingId: null,
      training: ''
    });

    this.setState({
      data: clonedData
    });
  };

  render() {
    const { onCloseModal } = this.props;
    const { data, btnIsDisabled } = this.state;
    return (
      <Modal title={TRAINING.TITLE} clickCloseIcon={onCloseModal} tabletSize>
        {data.map((item, index) => (
          <TrainingNeedsItem
            // eslint-disable-next-line
            key={`trainingneeds-${index}`}
            trainingId={item.trainingId}
            trainingData={data}
            order={index + 1}
            onClickDown={() => this.onClickOrderArrow(index, true)}
            onClickUp={() => this.onClickOrderArrow(index, false)}
            onClickDelete={() => this.onClickDelete(index)}
            onChangeTraining={e => {
              this.handleChange(e, index);
            }}
          />
        ))}
        {data.length < 5 && (
          <StyledButtonPlus dark onClick={this.handlePlus} tabletSize />
        )}
        <StyledBoxDown>
          <StyledButton onClick={onCloseModal} modal>
            {TRAINING.CANCEL}
          </StyledButton>
          <StyledButton
            onClick={this.handleAccept}
            secondary
            disabled={btnIsDisabled}
          >
            {TRAINING.ACCEPT}
          </StyledButton>
        </StyledBoxDown>
      </Modal>
    );
  }
}

TrainingNeeds.propTypes = {
  dataTrainingNeeds: PropTypes.arrayOf(
    PropTypes.shape({
      trainingId: PropTypes.number,
      training: PropTypes.string
    })
  ),
  onCloseModal: PropTypes.func,
  onAcceptModal: PropTypes.func
};

TrainingNeeds.defaultProps = {
  dataTrainingNeeds: []
};

export default TrainingNeeds;
